import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { StyledHeadTitle } from '@lib/common';
import { useEffect, useState } from 'react';
import { ClassStatusTag } from './class-status.component';
import { DetailHeader, Root, Main, StyledPageHeader, ClassContent, TabContent } from './class-detail.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ClassDetailLayout = function ClassDetailLayout(_ref) {
  var statusLabels = _ref.statusLabels,
      title = _ref.title,
      status = _ref.status,
      extra = _ref.extra,
      members = _ref.members,
      assignments = _ref.assignments,
      information = _ref.information,
      dashboard = _ref.dashboard,
      announcements = _ref.announcements,
      _ref$activePage = _ref.activePage,
      activePage = _ref$activePage === void 0 ? 'dashboard' : _ref$activePage;

  var _useState = useState([activePage]),
      visitedPages = _useState[0],
      setVisitedPages = _useState[1];

  var pages = visitedPages.includes(activePage) ? visitedPages : [].concat(_toConsumableArray(visitedPages), [activePage]);
  useEffect(function () {
    setVisitedPages(function (previous) {
      return previous.includes(activePage) ? previous : [].concat(_toConsumableArray(previous), [activePage]);
    });
  }, [activePage]);
  var views = {
    dashboard: dashboard,
    members: members,
    assignments: assignments,
    announcements: announcements,
    information: information
  };
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(DetailHeader, {
      children: /*#__PURE__*/_jsx(StyledPageHeader, {
        title: /*#__PURE__*/_jsx(StyledHeadTitle, {
          children: title
        }),
        tags: status ? /*#__PURE__*/_jsx(ClassStatusTag, {
          status: status,
          labels: statusLabels
        }) : undefined,
        extra: extra
      })
    }), /*#__PURE__*/_jsx(Main, {
      children: pages.map(function (page) {
        return /*#__PURE__*/_jsx(ClassContent, {
          $active: page === activePage,
          "aria-hidden": page !== activePage,
          children: page === 'members' || page === 'announcements' ? views[page] : /*#__PURE__*/_jsx(TabContent, {
            children: views[page]
          })
        }, page);
      })
    })]
  });
};